import { useParams } from 'react-router-dom'
import ModalDeleteFilled from '../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'


interface ModalDeleteProductComposedProps extends ModalEditComponentProps { }

const ModalDeleteProductComposed: React.FC<ModalDeleteProductComposedProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const params = useParams<{ id: string }>()
    const id = params.id
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/product/productComposed/deleteProductComposed',
        data: {
            ProductsComposedId: allRowData?.ProductsComposedId,
            ProductId: id
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteProductComposed', '¿Seguro quieres eliminar este producto compuesto?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteProductComposed